import DashboardButton from "@/atoms/DashboardButton";
import SingleArticle from "@/components/blog/singleArticle";
import routes from "@/constants/routes";
import Image from "next/image";
import Link from "next/link";
import { FC, Fragment } from "react";

type NeighbourhoodArticlesProps = {
  articles: Array<any>;
  searchTerm: string;
};

const NeighbourhoodArticles: FC<NeighbourhoodArticlesProps> = ({ articles, searchTerm }) => {
  return (
    <div className=" flex flex-col px-5 lg:px-[3rem] items-center justify-center">
      <div className="relative bg-white w-full overflow-hidden items-center">
        <div className="flex left-0 right-0 overflow-hidden bg-center bg-no-repeat bg-contain h-24 md:h-40 bg-[url('/intermediaries/city-article-ribbon-desktop.svg')]" />
      </div>

      <h2 className="text-4xl font-bold text-center xl:text-5xl text-landing-blue capitalize my-0 lg:my-4 xl:mt-8">
        Recent {searchTerm} articles
      </h2>
      <section className="flex flex-wrap items-center justify-between w-auto mt-5 max-w-[90rem] md:mb-12 mx-auto  xl:px-[3.75rem]  lg:w-3/4 ">
        {articles.slice(0, 2).map((article, idx) => (
          <Fragment key={idx}>
            <div className={`flex flex-col w-full md:w-1/2  md:px-4 py-4 md:py-0`}>
              <SingleArticle article={article as any} baseUrl={routes.blog} />
            </div>
          </Fragment>
        ))}
      </section>
      <Link href={routes.blog}>
        <div className="flex justify-center w-full md:w-auto ">
          <DashboardButton className="px-4 w-auto rounded-lg mt-5 md:mt-0" variant="submit">
            See all articles
          </DashboardButton>
        </div>
      </Link>
      <div className="relative mt-5">
        <Image
          src="/icons/thread-ribbon.png"
          alt="doodle"
          width={250}
          height={34}
          objectFit="none"
        />
      </div>
    </div>
  );
};

export default NeighbourhoodArticles;
